const october1 = [
  {
    id: 1,
    classRoom: '3-3',
    entry: 'Ustavno i privredno pravo',
    date: '2019-09-30',
    startTime: '11:35',
    endTime: '12:05'
  },
  {
    id: 2,
    classRoom: '4-3',
    entry: 'Ustavno i privredno pravo',
    date: '2019-09-30',
    startTime: '12:20',
    endTime: '12:50'
  },
  {
    id: 3,
    classRoom: '4-5',
    entry: 'Organizacija zastite od pozara',
    date: '2019-10-01',
    startTime: '11:00',
    endTime: '11:30'
  },
  {
    id: 4,
    classRoom: '4-5',
    entry: 'Organizacija zastite od pozara',
    date: '2019-10-01',
    startTime: '11:35',
    endTime: '12:05'
  },
  {
    id: 5,
    classRoom: '3-5',
    entry: 'Prakticna nastava',
    date: '2019-10-02',
    startTime: '11:00',
    endTime: '11:30'
  },
  {
    id: 6,
    classRoom: '3-5',
    entry: 'Prakticna nastava',
    date: '2019-10-02',
    startTime: '11:35',
    endTime: '12:05'
  },
  {
    id: 7,
    classRoom: '3-5',
    entry: 'Prakticna nastava',
    date: '2019-10-02',
    startTime: '12:20',
    endTime: '12:50'
  },
  {
    id: 8,
    classRoom: '3-5',
    entry: 'Prakticna nastava',
    date: '2019-10-02',
    startTime: '12:55',
    endTime: '13:25'
  },
  {
    id: 9,
    classRoom: '3-5',
    entry: 'Prakticna nastava',
    date: '2019-10-02',
    startTime: '13:30',
    endTime: '13:25'
  },
]

export default october1;